import React from 'react';
import bgImage from '../assets/aboutHero.png';

const AboutSection1 = () => {
    return (
        <div
        className="w-full text-white flex justify-start items-center pt-20 relative bg-cover bg-center min-h-[36vh] md:min-h-[50vh] lg:min-h-[70vh]"
        style={{
          backgroundImage: `url(${bgImage})`,
        }}
      >
      
            {/* Responsive height using Tailwind classes */}
            <div className="absolute inset-0 bg-[rgba(89,119,221,0.15)] z-0"></div>

            {/* Content container */}
            <div className="flex flex-col gap-6 sm:gap-8 md:gap-10 px-4 sm:px-8 md:px-16 lg:px-28 py-12 sm:py-16 md:py-20 z-10 w-full max-w-[1400px]">
                <div className="flex flex-col w-full max-w-[90%] sm:max-w-[600px] md:max-w-[750px] gap-4 sm:gap-6">
                    <p className="font-nunito text-[28px] sm:text-[36px] md:text-[30px] lg:text-[40px] leading-tight sm:leading-[48px] md:leading-[56px] lg:leading-[67.2px] text-left">
                        About Us
                    </p>
                    <p className="text-[14px] sm:text-[16px] md:text-[17px] lg:text-[18px] leading-relaxed sm:leading-[24px] md:leading-[26px] lg:leading-[28px] text-justify">
                        At eSparse Matrix Solutions, we provide one-stop software development services for all customers. We take care of all your needs, right from strategic concept development, business analysis, and software services to digital marketing — all in one place. Once you join eSparse Matrix Solutions, you will never have to go anywhere else again.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default AboutSection1;
